<template>
    <div :class="['car', type === 'mobile' ? 'car--mobile' : '']">
        <div class="title">
            Market Price of TANG Token as of {{ time }}
        </div>
        <div class="price">
            <!-- $ {{ price }} -->
             $ 0.036
        </div>
        <div class="info">
            Pending to be Launched for Public Sale
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Request from '@/core/request'
import Decimal from 'decimal.js'
import dayjs from 'dayjs'
// import { CountUp } from 'countup.js'

const props = defineProps({
    type: String
})

const time = ref()
const price = ref(0)

time.value = dayjs().format('DD/MM/YYYY')

const getPrice = () => {
    Request.get('/api/system/getTangPrice').then(res => {
        const { data } = res.data || {}
        const { tang_price } = data || {}
        // price.value = new Decimal(tang_price).div(Math.pow(10,18)).toString()
        price.value = 0.036;
        console.log(new Decimal(tang_price).div(Math.pow(10,18)).toString())

    })
}

const countUpStart = () => {
    // console.log(Number(price.value))
    // new CountUp('count', Number(price.value), 2).start()
}

onMounted(() => {
    getPrice()
})

defineExpose({ countUpStart })
</script>

<style scoped>
.car{
    padding: 53px 37px;
    background: #FFFFFF;
    box-shadow: 4px 5px 10px 2px rgba(0,0,0,0.12);
    border-radius: 37px;
    border: 1px solid #E1E1E1;
}
.title{
    font-weight: 400;
    font-size: 20px;
    color: #343434;
    line-height: 20px;
}
.price{
    font-weight: 600;
    font-size: 70px;
    color: #F16323;
    line-height: 80px;
    margin-top: 40px;
}
.info{
    font-weight: 400;
    font-size: 16px;
    color: #A8A8A8;
    line-height: 20px;
}
.car--mobile{
    padding: 21px 24px;
}
.car--mobile .title{
    font-size: 14px;
}
.car--mobile .price{
    margin-top: 0;
    font-size: 40px;
    line-height: 40px;
}
.car--mobile .info{
    margin-top: 0;
    font-size: 14px;
}
</style>